export const state = () => ({
    budgets: [],
    budget: null,
    meta: {},
    loading: false,
})

export const mutations = {
    SET_BUDGETS(state, data) {
        state.budgets = data
    },
    SET_BUDGET(state, data) {
        state.budget = data
        if (state.budgets && state.budgets.length) {
            const index = state.budgets.findIndex((item) => item.id === data.id)
            if (index !== -1) {
                state.budgets.splice(index, 1, data)
            } else {
                state.budgets.push(data)
            }
        }
    },
    SET_META(state, data) {
        state.meta = data
    },
    SET_LOADING(state, data) {
        state.loading = data
    },
}

export const actions = {
    async get({ commit, state }, { id }) {
        if (!id) throw new Error('Missing guest id!')
        commit('SET_LOADING', true)
        const response = await this.$axios.$get(`/api/v1/budget/${id}`)
        commit('SET_BUDGET', response.data)
        commit('SET_LOADING', false)
        return response
    },
    async getList({ commit, state }, { route, currentPage, perPage = 50 }) {
        commit('SET_LOADING', true)
        const params = {
            page: currentPage || route?.query?.page || 1,
            per_page: perPage || state.meta.per_page,
            type: route?.query?.type,
            transaction_type: route?.query?.transaction_type,
            search: route?.query?.q,
            order_by: route?.query?.['order-by'] || undefined,
            order_dir: route?.query?.['order-dir'] || 'desc',
        }
        if (route?.query && (route.query['filter-by'] == 'event' && route.query['filter-value'])) {
            params['event_id'] = route.query['filter-value']
        }

        const response = await this.$axios.$get(`/api/v1/budget`, {
            params: params,
        })
        commit('SET_BUDGETS', response.data)
        commit('SET_META', response.meta)
        commit('SET_LOADING', false)
        return response
    },
    async update({ commit, state }, item) {
        if (!item || !item.id) throw new Error('Missing budget id!')
        commit('SET_LOADING', true)
        const response = await this.$axios.$put(`/api/v1/budget/${item.id}`, item)
        commit('SET_BUDGET', response.data)
        commit('SET_LOADING', false)
        return response
    },
    async create({ commit, state }, item) {
        if (!item) throw new Error('Missing budget data!')
        commit('SET_LOADING', true)
        const response = await this.$axios.$post(`/api/v1/budget`, item)
        commit('SET_BUDGET', response.data)
        commit('SET_LOADING', false)
        return response
    },

    async delete({ commit, state }, items) {
        commit('SET_LOADING', true)
        const response = await this.$axios.$post(`/api/v1/budget/items/delete`, { items: items })
        commit('SET_LOADING', false)
        return response
    },
}
export const getters = {
    budgets: (state) => state.budgets,
    budget: (state) => state.budget,
    meta: (state) => state.meta,
    loading: (state) => state.loading,
}
